export enum NotificationUrgencyEnum {
  Navbar = 1,
  Modal = 2
}
